module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-view",
    style: ({
      paddingTop: _vm.height169 + 84 + 'px'
    })
  }, [_c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "fixedTop"
  }, [(_vm.share) ? _c('div', {
    staticClass: "video",
    style: ({
      height: _vm.height169 + 'px'
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "tip",
    style: ({
      height: _vm.height169 + 'px',
      textAlign: 'center'
    })
  }, [_vm._v("\n                该视频由福音影视网提供播放\n                "), _c('br'), _vm._v("WWW.FUYINTV.COM\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready && !_vm.share),
      expression: "ready && !share"
    }],
    staticClass: "video-container",
    style: ({
      height: _vm.height169 + 'px'
    })
  }, [_c('movie-video', {
    ref: "video",
    attrs: {
      "movie": _vm.movie
    },
    on: {
      "end": _vm.onPlayEnd
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "download",
    class: {
      off: !_vm.download
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.fytvapp.com"
    }
  }, [_c('i', {
    staticClass: "icon icon-loading"
  }), _vm._v(" "), _c('span', [_vm._v("点击下载福音TV APP功能更强大")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-download"
  })]), _vm._v(" "), _c('a', {
    staticClass: "icon icon-right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCloseDownload
    }
  })]), _vm._v(" "), _c('toolbar', {
    attrs: {
      "favourite": _vm.favourite
    },
    on: {
      "download": _vm.onOpenDownload,
      "intro": _vm.onIntro,
      "list": _vm.onList,
      "favourite": _vm.onFavourite,
      "note": _vm.onNote
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "current"
  }, [_vm._v("当前播放：" + _vm._s(_vm.current.title))])], 1), _vm._v(" "), (
    _vm.movie.zs &&
    _vm.movie.zs.open &&
    _vm.movie.zs.target !== 'miniprogram'
  ) ? _c('a', {
    staticClass: "ad",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onGoAd
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.movie.zs.image
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.movie.content)
    }
  })]) : _c('play-list', {
    attrs: {
      "player": _vm.player
    },
    on: {
      "video": _vm.onClickPlayVideo,
      "audio": _vm.onPlayAudio,
      "download-audio": _vm.onDownloadAudio,
      "pdf": _vm.onDownloadPdf
    }
  }), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d3ad184","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/movie/index.vue
// module id = 317
// module chunks = 0